module.exports = __webpack_public_path__ + "img/btn-minus.c01d1bc6.svg";